import { generateContext } from '@/context/utils';
import initialState from '@/context/compare/state';
import reducer from '@/context/compare/reducer';
import actions from '@/context/compare/actions';

const { CompareProvider, useCompareContext } = generateContext(
  'CompareProvider',
  'useCompareContext',
  initialState,
  reducer,
  actions,
);

export { CompareProvider, useCompareContext };
